import { MouseEvent } from 'react';
import CloseIcon from './icons/CloseIcon';
import { setGdpr, startGoogleAnalytics } from './gdpr-provider';

interface IConsentPopup {
    setPopupShown: Function,
    setData: Function,
}

const ConsentPopup = (props: IConsentPopup) => {

    const { setPopupShown, setData } = props;

    const close = () => {
        setPopupShown(false);
    };

    const prevent = (evt: MouseEvent) => {
        evt.stopPropagation();
    };

    /**
     * accept all cookies
     */
    const accept = () => {

        const updatedData = {
            accept: true,
        };

        setGdpr(updatedData);
        setData(updatedData);
        setPopupShown(false);

        startGoogleAnalytics();
    };

    /**
     * disable all cookies
     */
    const disable = () => {
        const updatedData = {
            accept: false,
        };

        setGdpr(updatedData);
        setData(updatedData);
        setPopupShown(false);
    };

    return (
        <div
            className="fixed bg-black/75 w-screen h-screen left-0 top-0 z-50 flex items-center justify-center"
            onClick={ close }>

            <div
                className="bg-white text-gray-900 rounded-xl mx-auto relative"
                style={{
                    width: '590px',
                    maxWidth: '95%'
                }}
                onClick={ prevent }>

                <button
                    type="button"
                    className="cursor-pointer absolute right-2 top-2"
                    onClick={ close }>
                    <CloseIcon />
                </button>

                <div className="p-10">
                    <p className="text-2xl mb-4">Cookie Settings</p>

                    <div className="text-sm">
                        <p className="mb-4">When you visit any of our websites, it may store or retrieve information on your browser, mostly in the form of cookies. This information might be about you, your preferences or your device and is mostly used to make the site work as you expect it to.</p>

                        <p className="mb-4">The information does not usually directly identify you, but it can give you a more personalized web experience. Because we respect your right to privacy, you can choose not to allow some types of cookies.</p>

                        <p className="mb-8">Please note, blocking some types of cookies may impact your experience of the site and the services we are able to offer.</p>
                    </div>

                    <div>
                        <button
                            type="button"
                            className="bg-cyan-600 text-gray-100 px-4 py-2 rounded mr-2"
                            onClick={ accept }>Accept all cookies</button>

                        <button
                            type="button"
                            className="bg-gray-300 text-gray-900 px-4 py-2 rounded mr-2 text-cyan-800"
                            onClick={ disable }>Disable cookies</button>

                        <button
                            type="button"
                            className="underline px-4 py-2 rounded mr-2 text-gray-900"
                            onClick={ close }>Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default ConsentPopup;